{
  "left": "Предыдущий",
  "right": "Следующий"
}
